import { createSlice } from "@reduxjs/toolkit";
import { savePartnerKey, saveIsOrthodox, saveIsMinor, PARTNER_KEYS } from "../utils/partner";

const initialState = {
  partner: PARTNER_KEYS.NONE,
  isOrthodox: true,
  isMinor: false,
  venueData: {},
};

const partnerSlice = createSlice({
  name: "partnerSlice",
  initialState,
  reducers: {
    setPartner: (state, action) => {
      const partnerId = action.payload;
      state.partner = partnerId;
      savePartnerKey(partnerId);
    },
    resetPartner: (state) => {
      state.partner = PARTNER_KEYS.NONE;
    },
    setIsOrthodox: (state, action) => {
      state.isOrthodox = action.payload;
      saveIsOrthodox(action.payload);
    },
    resetIsOrthodox: (state) => {
      state.isOrthodox = true;
    },
    setIsMinor: (state, action) => {
      state.isMinor = action.payload;
      saveIsMinor(action.payload);
    },
    resetIsMinor: (state) => {
      state.isMinor = false;
    },
    setVenueData: (state, action) => {
      state.venueData = action.payload;
    },
  },
});

export const { setPartner, resetPartner, setIsOrthodox, setIsMinor, resetIsOrthodox, setVenueData } = partnerSlice.actions;

export const selectPartner = (state) => state.partnerSlice.partner;
export const selectIsOrthodox = (state) => state.partnerSlice.isOrthodox;
export const selectIsMinor = (state) => state.partnerSlice.isMinor;
export const selectVenueData = (state) => state.partnerSlice.venueData;

//
export const isPartnerClalit = (state) => state.partnerSlice.partner === PARTNER_KEYS.CLALIT;
export const isPartnerMehudet = (state) => state.partnerSlice.partner === PARTNER_KEYS.MEHUDET;
export const isPartnerOvdimBari = (state) => state.partnerSlice.partner === PARTNER_KEYS.OVDIM_BARI;
export const isPartnerNone = (state) => state.partnerSlice.partner === PARTNER_KEYS.NONE;

export default partnerSlice.reducer;
